export default __webpack_public_path__ + "static/media/hellstrikes2.f47f6414.png";